import './EventLogsExpertMode.styles.scss';

import { observer } from 'mobx-react';
import { Avatar } from 'primereact/avatar';
import { FC, useEffect, useRef } from 'react';

import { GameStage } from '../../../../model/enumeration/GameStage.enum';
import { createEmptyEventsLog, LogEvent } from '../../../../model/LogsResponse';
import eventLogsStore from '../../../../store/EventLogsStore';
import { ACTION_COLORS } from '../../../Player/player.render.utils';
import { EventLogsExpertModeProps } from './EventLogsExpertMode.types';

const EventLogsExpertMode: FC<EventLogsExpertModeProps> = ({ tableId }) => {
  const eventLogsElementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    void eventLogsStore.getLogs(tableId);
  }, [tableId]);

  const eventsLog = eventLogsStore
    .getAllOpenedLogs()
    .find(log => log.tableId === tableId) ?? {
    tableId: '',
    events: createEmptyEventsLog(),
  };

  const scrollEventLogsEnd = (): void => {
    const messagesElement = eventLogsElementRef.current;
    if (messagesElement) {
      messagesElement.scrollTop = messagesElement.scrollHeight;
    }
  };

  useEffect(() => {
    scrollEventLogsEnd();
  }, [
    tableId,
    eventsLog.events.BLINDS.length,
    eventsLog.events.FLOP.length,
    eventsLog.events.PREFLOP.length,
    eventsLog.events.TURN.length,
  ]);

  return (
    <div
      className="EventLogsExpertMode-Component table-section-expert-mode"
      ref={eventLogsElementRef}
    >
      <div className="events-list">
        {Object.values(GameStage).map(stage => (
          <div key={stage} className="events-stage">
            {(() => {
              const logs = eventsLog.events[stage];

              return (
                logs &&
                logs.length > 0 && (
                  <>
                    <div className="events-stage-title">{stage}</div>
                    {logs.map((event: LogEvent, index: number) => (
                      <div
                        key={`${event.pid}-${stage}-${index}`}
                        className="events-item"
                      >
                        <Avatar
                          image={
                            event.myBot
                              ? '/assets/bot.svg'
                              : '/assets/player.svg'
                          }
                          shape="circle"
                          size="normal"
                          className="events-item-avatar"
                        />
                        <span className="events-item-nick">{event.nick}</span>
                        <span
                          className="events-item-action"
                          style={{ color: ACTION_COLORS.get(event.action) }}
                        >
                          {event.action
                            .replace('TYPE_', '')
                            .replace('STRADDLE', 'ST')}
                        </span>
                        {event.value ? (
                          <span className="events-item-value">
                            {event.value}
                          </span>
                        ) : null}
                      </div>
                    ))}
                  </>
                )
              );
            })()}
          </div>
        ))}
      </div>
    </div>
  );
};

export default observer(EventLogsExpertMode);
